/* tslint:disable */
/* eslint-disable */

/**
 * All available permissions in the system
 */
export enum WorkPermissionsEnum {
  ModuleAkquise = 'akquise:read',
  ModuleFinanzen = 'finanzen:read',
  AdminALL = 'all:admin',
  AdminMENU = 'admin:menu',
  WorkflowCREATE = 'workflows:create',
  WorkflowREAD = 'workflows:read',
  WorkflowUPDATE = 'workflows:update',
  WorkflowDELETE = 'workflows:delete',
  WorkflowADMIN = 'workflows:admin',
  VoucherCREATE = 'vouchers:create',
  VoucherREAD = 'vouchers:read',
  VoucherUPDATE = 'vouchers:update',
  VoucherDELETE = 'vouchers:delete',
  VoucherADMIN = 'vouchers:admin',
  VoucherAPPROVE = 'vouchers:approve',
  VoucherBOOK = 'vouchers:book',
  UsertrainingCREATE = 'usertrainings:create',
  UsertrainingREAD = 'usertrainings:read',
  UsertrainingUPDATE = 'usertrainings:update',
  UsertrainingDELETE = 'usertrainings:delete',
  UsertrainingADMIN = 'usertrainings:admin',
  UserCREATE = 'users:create',
  UserREAD = 'users:read',
  UserREAD_SENSITIVE = 'users:read-sensitive',
  UserUPDATE = 'users:update',
  UserDELETE = 'users:delete',
  UserADMIN = 'users:admin',
  UseremploymentCREATE = 'useremployments:create',
  UseremploymentREAD = 'useremployments:read',
  UseremploymentUPDATE = 'useremployments:update',
  UseremploymentDELETE = 'useremployments:delete',
  UseremploymentADMIN = 'useremployments:admin',
  UserconfigurationCREATE = 'userconfigurations:create',
  UserconfigurationREAD = 'userconfigurations:read',
  UserconfigurationUPDATE = 'userconfigurations:update',
  UserconfigurationDELETE = 'userconfigurations:delete',
  UserconfigurationADMIN = 'userconfigurations:admin',
  UploadCREATE = 'uploads:create',
  UploadREAD = 'uploads:read',
  UploadUPDATE = 'uploads:update',
  UploadDELETE = 'uploads:delete',
  UploadADMIN = 'uploads:admin',
  UnitCREATE = 'units:create',
  UnitREAD = 'units:read',
  UnitUPDATE = 'units:update',
  UnitDELETE = 'units:delete',
  UnitADMIN = 'units:admin',
  TrainingtypeCREATE = 'trainingtypes:create',
  TrainingtypeREAD = 'trainingtypes:read',
  TrainingtypeUPDATE = 'trainingtypes:update',
  TrainingtypeDELETE = 'trainingtypes:delete',
  TrainingtypeADMIN = 'trainingtypes:admin',
  TodoCREATE = 'todos:create',
  TodoREAD = 'todos:read',
  TodoUPDATE = 'todos:update',
  TodoDELETE = 'todos:delete',
  TodoADMIN = 'todos:admin',
  TitleCREATE = 'titles:create',
  TitleREAD = 'titles:read',
  TitleUPDATE = 'titles:update',
  TitleDELETE = 'titles:delete',
  TitleADMIN = 'titles:admin',
  TimerecordtypeCREATE = 'timerecordtypes:create',
  TimerecordtypeREAD = 'timerecordtypes:read',
  TimerecordtypeUPDATE = 'timerecordtypes:update',
  TimerecordtypeDELETE = 'timerecordtypes:delete',
  TimerecordtypeADMIN = 'timerecordtypes:admin',
  TimerecordCREATE = 'timerecords:create',
  TimerecordREAD = 'timerecords:read',
  TimerecordUPDATE = 'timerecords:update',
  TimerecordDELETE = 'timerecords:delete',
  TimerecordADMIN = 'timerecords:admin',
  TimerecorddetailCREATE = 'timerecorddetails:create',
  TimerecorddetailREAD = 'timerecorddetails:read',
  TimerecorddetailUPDATE = 'timerecorddetails:update',
  TimerecorddetailDELETE = 'timerecorddetails:delete',
  TimerecorddetailADMIN = 'timerecorddetails:admin',
  TimerecordHolidayCREATE = 'timerecord-holidays:create',
  TimerecordHolidayREAD = 'timerecord-holidays:read',
  TimerecordHolidayUPDATE = 'timerecord-holidays:update',
  TimerecordHolidayDELETE = 'timerecord-holidays:delete',
  TimerecordHolidayADMIN = 'timerecord-holidays:admin',
  TimerecordbalanceCREATE = 'timerecordbalances:create',
  TimerecordbalanceREAD = 'timerecordbalances:read',
  TimerecordbalanceUPDATE = 'timerecordbalances:update',
  TimerecordbalanceDELETE = 'timerecordbalances:delete',
  TimerecordbalanceADMIN = 'timerecordbalances:admin',
  TimerecordBalanceCREATE = 'timerecord-balances:create',
  TimerecordBalanceREAD = 'timerecord-balances:read',
  TimerecordBalanceUPDATE = 'timerecord-balances:update',
  TimerecordBalanceDELETE = 'timerecord-balances:delete',
  TimerecordBalanceADMIN = 'timerecord-balances:admin',
  TimeDimensionCREATE = 'time-dimensions:create',
  TimeDimensionREAD = 'time-dimensions:read',
  TimeDimensionUPDATE = 'time-dimensions:update',
  TimeDimensionDELETE = 'time-dimensions:delete',
  TimeDimensionADMIN = 'time-dimensions:admin',
  TimeBlockTemplatesCREATE = 'time-block-templates:create',
  TimeBlockTemplatesREAD = 'time-block-templates:read',
  TimeBlockTemplatesUPDATE = 'time-block-templates:update',
  TimeBlockTemplatesDELETE = 'time-block-templates:delete',
  TimeBlockTemplatesADMIN = 'time-block-templates:admin',
  TimeBlockTemplateEntriesCREATE = 'time-block-template-entries:create',
  TimeBlockTemplateEntriesREAD = 'time-block-template-entries:read',
  TimeBlockTemplateEntriesUPDATE = 'time-block-template-entries:update',
  TimeBlockTemplateEntriesDELETE = 'time-block-template-entries:delete',
  TimeBlockTemplateEntriesADMIN = 'time-block-template-entries:admin',
  TicketCREATE = 'tickets:create',
  TicketREAD = 'tickets:read',
  TicketUPDATE = 'tickets:update',
  TicketDELETE = 'tickets:delete',
  TicketADMIN = 'tickets:admin',
  TicketUserChangeCREATE = 'ticket-user-changes:create',
  TicketUserChangeREAD = 'ticket-user-changes:read',
  TicketUserChangeUPDATE = 'ticket-user-changes:update',
  TicketUserChangeDELETE = 'ticket-user-changes:delete',
  TicketUserChangeADMIN = 'ticket-user-changes:admin',
  TicketStatusChangeCREATE = 'ticket-status-changes:create',
  TicketStatusChangeREAD = 'ticket-status-changes:read',
  TicketStatusChangeUPDATE = 'ticket-status-changes:update',
  TicketStatusChangeDELETE = 'ticket-status-changes:delete',
  TicketStatusChangeADMIN = 'ticket-status-changes:admin',
  TenantCREATE = 'tenants:create',
  TenantREAD = 'tenants:read',
  TenantUPDATE = 'tenants:update',
  TenantDELETE = 'tenants:delete',
  TenantADMIN = 'tenants:admin',
  TeamCREATE = 'teams:create',
  TeamREAD = 'teams:read',
  TeamUPDATE = 'teams:update',
  TeamDELETE = 'teams:delete',
  TeamADMIN = 'teams:admin',
  TeammembershipCREATE = 'teammemberships:create',
  TeammembershipREAD = 'teammemberships:read',
  TeammembershipUPDATE = 'teammemberships:update',
  TeammembershipDELETE = 'teammemberships:delete',
  TeammembershipADMIN = 'teammemberships:admin',
  TasktypeCREATE = 'tasktypes:create',
  TasktypeREAD = 'tasktypes:read',
  TasktypeUPDATE = 'tasktypes:update',
  TasktypeDELETE = 'tasktypes:delete',
  TasktypeADMIN = 'tasktypes:admin',
  TaskCREATE = 'tasks:create',
  TaskREAD = 'tasks:read',
  TaskUPDATE = 'tasks:update',
  TaskDELETE = 'tasks:delete',
  TaskADMIN = 'tasks:admin',
  TaskgroupCREATE = 'taskgroups:create',
  TaskgroupREAD = 'taskgroups:read',
  TaskgroupUPDATE = 'taskgroups:update',
  TaskgroupDELETE = 'taskgroups:delete',
  TaskgroupADMIN = 'taskgroups:admin',
  TaskTabADMIN = 'task-tabs:admin',
  TagCREATE = 'tags:create',
  TagREAD = 'tags:read',
  TagUPDATE = 'tags:update',
  TagDELETE = 'tags:delete',
  TagADMIN = 'tags:admin',
  TablesoccerCREATE = 'tablesoccer:create',
  TablesoccerREAD = 'tablesoccer:read',
  TablesoccerUPDATE = 'tablesoccer:update',
  TablesoccerDELETE = 'tablesoccer:delete',
  TablesoccerADMIN = 'tablesoccer:admin',
  SupplierCREATE = 'suppliers:create',
  SupplierREAD = 'suppliers:read',
  SupplierUPDATE = 'suppliers:update',
  SupplierDELETE = 'suppliers:delete',
  SupplierADMIN = 'suppliers:admin',
  StocklocationCREATE = 'stocklocations:create',
  StocklocationREAD = 'stocklocations:read',
  StocklocationUPDATE = 'stocklocations:update',
  StocklocationDELETE = 'stocklocations:delete',
  StocklocationADMIN = 'stocklocations:admin',
  StatusCREATE = 'status:create',
  StatusREAD = 'status:read',
  StatusUPDATE = 'status:update',
  StatusDELETE = 'status:delete',
  StatusADMIN = 'status:admin',
  StandardtaskCREATE = 'standardtasks:create',
  StandardtaskREAD = 'standardtasks:read',
  StandardtaskUPDATE = 'standardtasks:update',
  StandardtaskDELETE = 'standardtasks:delete',
  StandardtaskADMIN = 'standardtasks:admin',
  StandardtaskgroupCREATE = 'standardtaskgroups:create',
  StandardtaskgroupREAD = 'standardtaskgroups:read',
  StandardtaskgroupUPDATE = 'standardtaskgroups:update',
  StandardtaskgroupDELETE = 'standardtaskgroups:delete',
  StandardtaskgroupADMIN = 'standardtaskgroups:admin',
  ProjectShareUPDATE = 'project-shares:update',
  ProjectShareADMIN = 'project-shares:admin',
  SerialnumbersUnregisteredCREATE = 'serialnumbers-unregistered:create',
  SerialnumbersUnregisteredREAD = 'serialnumbers-unregistered:read',
  SerialnumbersUnregisteredUPDATE = 'serialnumbers-unregistered:update',
  SerialnumbersUnregisteredDELETE = 'serialnumbers-unregistered:delete',
  SerialnumbersUnregisteredADMIN = 'serialnumbers-unregistered:admin',
  SerialnumberCREATE = 'serialnumbers:create',
  SerialnumberREAD = 'serialnumbers:read',
  SerialnumberUPDATE = 'serialnumbers:update',
  SerialnumberDELETE = 'serialnumbers:delete',
  SerialnumberADMIN = 'serialnumbers:admin',
  ScreenslideCREATE = 'screenslides:create',
  ScreenslideREAD = 'screenslides:read',
  ScreenslideUPDATE = 'screenslides:update',
  ScreenslideDELETE = 'screenslides:delete',
  ScreenslideADMIN = 'screenslides:admin',
  ScreenslideComponentCREATE = 'screenslide-components:create',
  ScreenslideComponentREAD = 'screenslide-components:read',
  ScreenslideComponentUPDATE = 'screenslide-components:update',
  ScreenslideComponentDELETE = 'screenslide-components:delete',
  ScreenslideComponentADMIN = 'screenslide-components:admin',
  ScreendeviceCREATE = 'screendevices:create',
  ScreendeviceREAD = 'screendevices:read',
  ScreendeviceUPDATE = 'screendevices:update',
  ScreendeviceDELETE = 'screendevices:delete',
  ScreendeviceADMIN = 'screendevices:admin',
  ScreenCREATE = 'screen:create',
  ScreenREAD = 'screen:read',
  ScreenUPDATE = 'screen:update',
  ScreenDELETE = 'screen:delete',
  ScreenADMIN = 'screen:admin',
  ScreendeviceSlideCREATE = 'screendevice-slides:create',
  ScreendeviceSlideREAD = 'screendevice-slides:read',
  ScreendeviceSlideUPDATE = 'screendevice-slides:update',
  ScreendeviceSlideDELETE = 'screendevice-slides:delete',
  ScreendeviceSlideADMIN = 'screendevice-slides:admin',
  ScreencomponentCREATE = 'screencomponents:create',
  ScreencomponentREAD = 'screencomponents:read',
  ScreencomponentUPDATE = 'screencomponents:update',
  ScreencomponentDELETE = 'screencomponents:delete',
  ScreencomponentADMIN = 'screencomponents:admin',
  RoletypeCREATE = 'roletypes:create',
  RoletypeREAD = 'roletypes:read',
  RoletypeUPDATE = 'roletypes:update',
  RoletypeDELETE = 'roletypes:delete',
  RoletypeADMIN = 'roletypes:admin',
  RoleCREATE = 'roles:create',
  RoleREAD = 'roles:read',
  RoleUPDATE = 'roles:update',
  RoleDELETE = 'roles:delete',
  RoleADMIN = 'roles:admin',
  RevenueRebateCREATE = 'revenue-rebates:create',
  RevenueRebateREAD = 'revenue-rebates:read',
  RevenueRebateUPDATE = 'revenue-rebates:update',
  RevenueRebateDELETE = 'revenue-rebates:delete',
  RevenueRebateADMIN = 'revenue-rebates:admin',
  ReservationtypeCREATE = 'reservationtypes:create',
  ReservationtypeREAD = 'reservationtypes:read',
  ReservationtypeUPDATE = 'reservationtypes:update',
  ReservationtypeDELETE = 'reservationtypes:delete',
  ReservationtypeADMIN = 'reservationtypes:admin',
  ReservationteamCREATE = 'reservationteams:create',
  ReservationteamREAD = 'reservationteams:read',
  ReservationteamUPDATE = 'reservationteams:update',
  ReservationteamDELETE = 'reservationteams:delete',
  ReservationteamADMIN = 'reservationteams:admin',
  ReservationCREATE = 'reservations:create',
  ReservationREAD = 'reservations:read',
  ReservationUPDATE = 'reservations:update',
  ReservationDELETE = 'reservations:delete',
  ReservationADMIN = 'reservations:admin',
  ReportABGRENZUNGEN = 'reports:abgrenzungen',
  ReportABSENCES = 'reports:absences',
  ReportAUSSTEHENDE_AUFGABEN = 'reports:ausstehende-aufgaben',
  ReportDEBITORENABSTIMMUNG = 'reports:debitorenabstimmung',
  ReportNOCH_NICHT_FAKTURIERTE_LEISTUNGEN = 'reports:noch-nicht-fakturierte-leistungen',
  ReportINTERESTING_STATS_FOR_YEAR = 'reports:interesting-stats-for-year',
  ReportJAHRESENDVERARBEITUNG = 'reports:jahresendverabeitung',
  ReportLAGERBESTAND = 'reports:lagerbestand',
  ReportLEADCONVERSION = 'reports:leadconversion',
  ReportLOHNLAUF = 'reports:lohnlauf',
  ReportLOHNLISTE = 'reports:lohnliste',
  ReportPERFORMANCE_KUNDENBERATER = 'reports:performance-kundenberater',
  ReportPERFORMANCE_KUNDENSUPPORT = 'reports:performance-kundensupport',
  ReportPERFORMANCE_MONTAGE = 'reports:performance-montage',
  ReportPROGNOSTIZIERTER_UMSATZ = 'reports:prognostizierter-umsatz',
  ReportSENS_DEKLARATION = 'reports:sens-deklaration',
  ReportSTUNDENMELDUNG_TEMPORAERE_MITARBEITER = 'reports:stundenmeldung-temporaere-mitarbeiter',
  ReportUMSATZ_DECKUNGSBEITRAG_BAU = 'reports:umsatz-deckungsbeitrag-bau',
  ReportUMSATZ_DECKUNGSBEITRAG_VERKAUF = 'reports:umsatz-deckungsbeitrag-verkauf',
  RefreshtokenCREATE = 'refreshtokens:create',
  RefreshtokenREAD = 'refreshtokens:read',
  RefreshtokenUPDATE = 'refreshtokens:update',
  RefreshtokenDELETE = 'refreshtokens:delete',
  RefreshtokenADMIN = 'refreshtokens:admin',
  ReferralCREATE = 'referrals:create',
  ReferralREAD = 'referrals:read',
  ReferralUPDATE = 'referrals:update',
  ReferralDELETE = 'referrals:delete',
  ReferralADMIN = 'referrals:admin',
  ReasontypeCREATE = 'reasontypes:create',
  ReasontypeREAD = 'reasontypes:read',
  ReasontypeUPDATE = 'reasontypes:update',
  ReasontypeDELETE = 'reasontypes:delete',
  ReasontypeADMIN = 'reasontypes:admin',
  RealestatetypeCREATE = 'realestatetypes:create',
  RealestatetypeREAD = 'realestatetypes:read',
  RealestatetypeUPDATE = 'realestatetypes:update',
  RealestatetypeDELETE = 'realestatetypes:delete',
  RealestatetypeADMIN = 'realestatetypes:admin',
  PushNotificationTokenCREATE = 'push-notification-tokens:create',
  PushNotificationTokenREAD = 'push-notification-tokens:read',
  PushNotificationTokenUPDATE = 'push-notification-tokens:update',
  PushNotificationTokenDELETE = 'push-notification-tokens:delete',
  PushNotificationTokenADMIN = 'push-notification-tokens:admin',
  ProspectCREATE = 'prospects:create',
  ProspectREAD = 'prospects:read',
  ProspectUPDATE = 'prospects:update',
  ProspectDELETE = 'prospects:delete',
  ProspectADMIN = 'prospects:admin',
  ProjectCREATE = 'projects:create',
  ProjectREAD = 'projects:read',
  ProjectUPDATE = 'projects:update',
  ProjectDELETE = 'projects:delete',
  ProjectADMIN = 'projects:admin',
  ProjectSTORNO = 'projects:storno',
  MontageplanADMIN = 'montageplan:admin',
  MontageplanREAD = 'montageplan:read',
  MontageplanMOVE = 'montageplan:move',
  MontageplanUPDATE = 'montageplan:update',
  MontageplanINSERT = 'montageplan:insert',
  MontageplanNOTES = 'montageplan:notes',
  GeruestbauCREATE = 'geruestbau:create',
  GeruestbauREAD = 'geruestbau:read',
  GeruestbauUPDATE = 'geruestbau:update',
  GeruestbauDELETE = 'geruestbau:delete',
  GeruestbauADMIN = 'geruestbau:admin',
  GeruestbauCOMPLETE = 'geruestbau:complete',
  GeruestbauASSIGN = 'geruestbau:assign',
  GeruestbauACCEPT = 'geruestbau:accept',
  GeruestbauDECLINE = 'geruestbau:decline',
  ElektroDrittkontrolleCREATE = 'elektrodrittkontrolle:create',
  ElektroDrittkontrolleREAD = 'elektrodrittkontrolle:read',
  ElektroDrittkontrolleUPDATE = 'elektrodrittkontrolle:update',
  ElektroDrittkontrolleDELETE = 'elektrodrittkontrolle:delete',
  ElektroDrittkontrolleADMIN = 'elektrodrittkontrolle:admin',
  ElektroDrittkontrolleCOMPLETE = 'elektrodrittkontrolle:complete',
  ElektroDrittkontrolleASSIGN = 'elektrodrittkontrolle:assign',
  ElektroDrittkontrolleACCEPT = 'elektrodrittkontrolle:accept',
  ElektroDrittkontrolleBILL = 'elektrodrittkontrolle:bill',
  ElektroDrittkontrolleDECLINE = 'elektrodrittkontrolle:decline',
  ProjectrevenueCREATE = 'projectrevenues:create',
  ProjectrevenueREAD = 'projectrevenues:read',
  ProjectrevenueUPDATE = 'projectrevenues:update',
  ProjectrevenueDELETE = 'projectrevenues:delete',
  ProjectrevenueADMIN = 'projectrevenues:admin',
  ProjectdossierTemplateCREATE = 'projectdossier-templates:create',
  ProjectdossierTemplateREAD = 'projectdossier-templates:read',
  ProjectdossierTemplateUPDATE = 'projectdossier-templates:update',
  ProjectdossierTemplateDELETE = 'projectdossier-templates:delete',
  ProjectdossierTemplateADMIN = 'projectdossier-templates:admin',
  ProjectdossierUPDATE = 'projectdossiers:update',
  ProjectdossierADMIN = 'projectdossiers:admin',
  ProjectHouseSideCREATE = 'project-house-sides:create',
  ProjectHouseSideREAD = 'project-house-sides:read',
  ProjectHouseSideUPDATE = 'project-house-sides:update',
  ProjectHouseSideDELETE = 'project-house-sides:delete',
  ProjectHouseSideADMIN = 'project-house-sides:admin',
  ProjectCheckRuleCREATE = 'project-check-rules:create',
  ProjectCheckRuleREAD = 'project-check-rules:read',
  ProjectCheckRuleUPDATE = 'project-check-rules:update',
  ProjectCheckRuleDELETE = 'project-check-rules:delete',
  ProjectCheckRuleADMIN = 'project-check-rules:admin',
  ProductgroupCREATE = 'productgroups:create',
  ProductgroupREAD = 'productgroups:read',
  ProductgroupUPDATE = 'productgroups:update',
  ProductgroupDELETE = 'productgroups:delete',
  ProductgroupADMIN = 'productgroups:admin',
  PriceCREATE = 'prices:create',
  PriceREAD = 'prices:read',
  PriceUPDATE = 'prices:update',
  PriceDELETE = 'prices:delete',
  PriceADMIN = 'prices:admin',
  PriceTierCREATE = 'price-tiers:create',
  PriceTierREAD = 'price-tiers:read',
  PriceTierUPDATE = 'price-tiers:update',
  PriceTierDELETE = 'price-tiers:delete',
  PriceTierADMIN = 'price-tiers:admin',
  PowermembershipCREATE = 'powermemberships:create',
  PowermembershipREAD = 'powermemberships:read',
  PowermembershipUPDATE = 'powermemberships:update',
  PowermembershipDELETE = 'powermemberships:delete',
  PowermembershipADMIN = 'powermemberships:admin',
  PhonetypeCREATE = 'phonetypes:create',
  PhonetypeREAD = 'phonetypes:read',
  PhonetypeUPDATE = 'phonetypes:update',
  PhonetypeDELETE = 'phonetypes:delete',
  PhonetypeADMIN = 'phonetypes:admin',
  PhoneCREATE = 'phones:create',
  PhoneREAD = 'phones:read',
  PhoneUPDATE = 'phones:update',
  PhoneDELETE = 'phones:delete',
  PhoneADMIN = 'phones:admin',
  PersonnelFileCREATE = 'personnelfiles:create',
  PersonnelFileREAD = 'personnelfiles:read',
  PersonnelFileUPDATE = 'personnelfiles:update',
  PersonnelFileDELETE = 'personnelfiles:delete',
  PersonnelFileADMIN = 'personnelfiles:admin',
  PermissionCREATE = 'permissions:create',
  PermissionREAD = 'permissions:read',
  PermissionUPDATE = 'permissions:update',
  PermissionDELETE = 'permissions:delete',
  PermissionADMIN = 'permissions:admin',
  PasswordResetTokenCREATE = 'password-reset-tokens:create',
  PasswordResetTokenREAD = 'password-reset-tokens:read',
  PasswordResetTokenUPDATE = 'password-reset-tokens:update',
  PasswordResetTokenDELETE = 'password-reset-tokens:delete',
  PasswordResetTokenADMIN = 'password-reset-tokens:admin',
  OutcometypeCREATE = 'outcometypes:create',
  OutcometypeREAD = 'outcometypes:read',
  OutcometypeUPDATE = 'outcometypes:update',
  OutcometypeDELETE = 'outcometypes:delete',
  OutcometypeADMIN = 'outcometypes:admin',
  OrderCREATE = 'orders:create',
  OrderREAD = 'orders:read',
  OrderUPDATE = 'orders:update',
  OrderDELETE = 'orders:delete',
  OrderADMIN = 'orders:admin',
  OnetimepasswordCREATE = 'onetimepasswords:create',
  OnetimepasswordREAD = 'onetimepasswords:read',
  OnetimepasswordUPDATE = 'onetimepasswords:update',
  OnetimepasswordDELETE = 'onetimepasswords:delete',
  OnetimepasswordADMIN = 'onetimepasswords:admin',
  NotificationCREATE = 'notifications:create',
  NotificationREAD = 'notifications:read',
  NotificationUPDATE = 'notifications:update',
  NotificationDELETE = 'notifications:delete',
  NotificationADMIN = 'notifications:admin',
  NewsCREATE = 'news:create',
  NewsREAD = 'news:read',
  NewsUPDATE = 'news:update',
  NewsDELETE = 'news:delete',
  NewsADMIN = 'news:admin',
  MontageplanLogCREATE = 'montageplan-logs:create',
  MontageplanLogREAD = 'montageplan-logs:read',
  MontageplanLogUPDATE = 'montageplan-logs:update',
  MontageplanLogDELETE = 'montageplan-logs:delete',
  MontageplanLogADMIN = 'montageplan-logs:admin',
  MessagingTemplateCREATE = 'messaging-templates:create',
  MessagingTemplateREAD = 'messaging-templates:read',
  MessagingTemplateUPDATE = 'messaging-templates:update',
  MessagingTemplateDELETE = 'messaging-templates:delete',
  MessagingTemplateADMIN = 'messaging-templates:admin',
  MessagingUSERS = 'messaging:users',
  MessagingCONTACTS = 'messaging:contacts',
  MessagingADMIN = 'messaging:admin',
  MeetingCREATE = 'meetings:create',
  MeetingREAD = 'meetings:read',
  MeetingUPDATE = 'meetings:update',
  MeetingDELETE = 'meetings:delete',
  MeetingADMIN = 'meetings:admin',
  MeetingTypeCREATE = 'meeting-types:create',
  MeetingTypeREAD = 'meeting-types:read',
  MeetingTypeUPDATE = 'meeting-types:update',
  MeetingTypeDELETE = 'meeting-types:delete',
  MeetingTypeADMIN = 'meeting-types:admin',
  MeetingParticipantCREATE = 'meeting-participants:create',
  MeetingParticipantREAD = 'meeting-participants:read',
  MeetingParticipantUPDATE = 'meeting-participants:update',
  MeetingParticipantDELETE = 'meeting-participants:delete',
  MeetingParticipantADMIN = 'meeting-participants:admin',
  MeetingDecisionCREATE = 'meeting-decisions:create',
  MeetingDecisionREAD = 'meeting-decisions:read',
  MeetingDecisionUPDATE = 'meeting-decisions:update',
  MeetingDecisionDELETE = 'meeting-decisions:delete',
  MeetingDecisionADMIN = 'meeting-decisions:admin',
  MeetingAgendaItemCREATE = 'meeting-agenda-items:create',
  MeetingAgendaItemREAD = 'meeting-agenda-items:read',
  MeetingAgendaItemUPDATE = 'meeting-agenda-items:update',
  MeetingAgendaItemDELETE = 'meeting-agenda-items:delete',
  MeetingAgendaItemADMIN = 'meeting-agenda-items:admin',
  MailtypeCREATE = 'mailtypes:create',
  MailtypeREAD = 'mailtypes:read',
  MailtypeUPDATE = 'mailtypes:update',
  MailtypeDELETE = 'mailtypes:delete',
  MailtypeADMIN = 'mailtypes:admin',
  MailtemplateCREATE = 'mailtemplates:create',
  MailtemplateREAD = 'mailtemplates:read',
  MailtemplateUPDATE = 'mailtemplates:update',
  MailtemplateDELETE = 'mailtemplates:delete',
  MailtemplateADMIN = 'mailtemplates:admin',
  MailCREATE = 'mails:create',
  MailREAD = 'mails:read',
  MailUPDATE = 'mails:update',
  MailDELETE = 'mails:delete',
  MailADMIN = 'mails:admin',
  LocationCREATE = 'locations:create',
  LocationREAD = 'locations:read',
  LocationUPDATE = 'locations:update',
  LocationDELETE = 'locations:delete',
  LocationADMIN = 'locations:admin',
  LeadsubcategoryCREATE = 'leadsubcategories:create',
  LeadsubcategoryREAD = 'leadsubcategories:read',
  LeadsubcategoryUPDATE = 'leadsubcategories:update',
  LeadsubcategoryDELETE = 'leadsubcategories:delete',
  LeadsubcategoryADMIN = 'leadsubcategories:admin',
  LeadcategoryCREATE = 'leadcategories:create',
  LeadcategoryREAD = 'leadcategories:read',
  LeadcategoryUPDATE = 'leadcategories:update',
  LeadcategoryDELETE = 'leadcategories:delete',
  LeadcategoryADMIN = 'leadcategories:admin',
  ItemCREATE = 'items:create',
  ItemREAD = 'items:read',
  ItemUPDATE = 'items:update',
  ItemDELETE = 'items:delete',
  ItemADMIN = 'items:admin',
  ItemGroupCREATE = 'itemgroups:create',
  ItemGroupREAD = 'itemgroups:read',
  ItemGroupUPDATE = 'itemgroups:update',
  ItemGroupDELETE = 'itemgroups:delete',
  ItemGroupADMIN = 'itemgroups:admin',
  ItemRestrictionCREATE = 'item-restrictions:create',
  ItemRestrictionREAD = 'item-restrictions:read',
  ItemRestrictionUPDATE = 'item-restrictions:update',
  ItemRestrictionDELETE = 'item-restrictions:delete',
  ItemRestrictionADMIN = 'item-restrictions:admin',
  ItemCompatibilityCREATE = 'item-compatibilities:create',
  ItemCompatibilityREAD = 'item-compatibilities:read',
  ItemCompatibilityUPDATE = 'item-compatibilities:update',
  ItemCompatibilityDELETE = 'item-compatibilities:delete',
  ItemCompatibilityADMIN = 'item-compatibilities:admin',
  InteractiontypeCREATE = 'interactiontypes:create',
  InteractiontypeREAD = 'interactiontypes:read',
  InteractiontypeUPDATE = 'interactiontypes:update',
  InteractiontypeDELETE = 'interactiontypes:delete',
  InteractiontypeADMIN = 'interactiontypes:admin',
  InteractionCREATE = 'interactions:create',
  InteractionREAD = 'interactions:read',
  InteractionUPDATE = 'interactions:update',
  InteractionDELETE = 'interactions:delete',
  InteractionADMIN = 'interactions:admin',
  EventCREATE = 'events:create',
  EventREAD = 'events:read',
  EventUPDATE = 'events:update',
  EventDELETE = 'events:delete',
  EventADMIN = 'events:admin',
  EventTypeCREATE = 'event-types:create',
  EventTypeREAD = 'event-types:read',
  EventTypeUPDATE = 'event-types:update',
  EventTypeDELETE = 'event-types:delete',
  EventTypeADMIN = 'event-types:admin',
  EventRegistrationSelectedOptionCREATE = 'event-registration-selected-options:create',
  EventRegistrationSelectedOptionREAD = 'event-registration-selected-options:read',
  EventRegistrationSelectedOptionUPDATE = 'event-registration-selected-options:update',
  EventRegistrationSelectedOptionDELETE = 'event-registration-selected-options:delete',
  EventRegistrationSelectedOptionADMIN = 'event-registration-selected-options:admin',
  EventRegistrationOptionCREATE = 'event-registration-options:create',
  EventRegistrationOptionREAD = 'event-registration-options:read',
  EventRegistrationOptionUPDATE = 'event-registration-options:update',
  EventRegistrationOptionDELETE = 'event-registration-options:delete',
  EventRegistrationOptionADMIN = 'event-registration-options:admin',
  EventRegistrationOptionGroupCREATE = 'event-registration-option-groups:create',
  EventRegistrationOptionGroupREAD = 'event-registration-option-groups:read',
  EventRegistrationOptionGroupUPDATE = 'event-registration-option-groups:update',
  EventRegistrationOptionGroupDELETE = 'event-registration-option-groups:delete',
  EventRegistrationOptionGroupADMIN = 'event-registration-option-groups:admin',
  EventInvitationCREATE = 'event-invitations:create',
  EventInvitationREAD = 'event-invitations:read',
  EventInvitationUPDATE = 'event-invitations:update',
  EventInvitationDELETE = 'event-invitations:delete',
  EventInvitationADMIN = 'event-invitations:admin',
  EventInvitationTypeCREATE = 'event-invitation-types:create',
  EventInvitationTypeREAD = 'event-invitation-types:read',
  EventInvitationTypeUPDATE = 'event-invitation-types:update',
  EventInvitationTypeDELETE = 'event-invitation-types:delete',
  EventInvitationTypeADMIN = 'event-invitation-types:admin',
  EquipmenttypeCREATE = 'equipmenttypes:create',
  EquipmenttypeREAD = 'equipmenttypes:read',
  EquipmenttypeUPDATE = 'equipmenttypes:update',
  EquipmenttypeDELETE = 'equipmenttypes:delete',
  EquipmenttypeADMIN = 'equipmenttypes:admin',
  EquipmentCREATE = 'equipments:create',
  EquipmentREAD = 'equipments:read',
  EquipmentUPDATE = 'equipments:update',
  EquipmentDELETE = 'equipments:delete',
  EquipmentADMIN = 'equipments:admin',
  EquipmentEQUIPMENTTYPES_ADMIN = 'equipmenttypes:admin',
  EquipmentlogtypeCREATE = 'equipmentlogtypes:create',
  EquipmentlogtypeREAD = 'equipmentlogtypes:read',
  EquipmentlogtypeUPDATE = 'equipmentlogtypes:update',
  EquipmentlogtypeDELETE = 'equipmentlogtypes:delete',
  EquipmentlogtypeADMIN = 'equipmentlogtypes:admin',
  EquipmentlogCREATE = 'equipmentlogs:create',
  EquipmentlogREAD = 'equipmentlogs:read',
  EquipmentlogUPDATE = 'equipmentlogs:update',
  EquipmentlogDELETE = 'equipmentlogs:delete',
  EquipmentlogADMIN = 'equipmentlogs:admin',
  EquipmentlogCHECKIN = 'equipmentlogs:checkin',
  EquipmentlogCHECKOUT = 'equipmentlogs:checkout',
  EquipmentlogDEFEKT = 'equipmentlogs:defekt',
  EquipmentlogREPARATUR = 'equipmentlogs:reparatur',
  EquipmentintervalCREATE = 'equipmentintervals:create',
  EquipmentintervalREAD = 'equipmentintervals:read',
  EquipmentintervalUPDATE = 'equipmentintervals:update',
  EquipmentintervalDELETE = 'equipmentintervals:delete',
  EquipmentintervalADMIN = 'equipmentintervals:admin',
  ElectricalMeasurementCREATE = 'electrical-measurements:create',
  ElectricalMeasurementREAD = 'electrical-measurements:read',
  ElectricalMeasurementUPDATE = 'electrical-measurements:update',
  ElectricalMeasurementDELETE = 'electrical-measurements:delete',
  ElectricalMeasurementADMIN = 'electrical-measurements:admin',
  ElectricalMeasurementTypeCREATE = 'electrical-measurement-types:create',
  ElectricalMeasurementTypeREAD = 'electrical-measurement-types:read',
  ElectricalMeasurementTypeUPDATE = 'electrical-measurement-types:update',
  ElectricalMeasurementTypeDELETE = 'electrical-measurement-types:delete',
  ElectricalMeasurementTypeADMIN = 'electrical-measurement-types:admin',
  ElectricalMeasurementDeviceCREATE = 'electrical-measurement-devices:create',
  ElectricalMeasurementDeviceREAD = 'electrical-measurement-devices:read',
  ElectricalMeasurementDeviceUPDATE = 'electrical-measurement-devices:update',
  ElectricalMeasurementDeviceDELETE = 'electrical-measurement-devices:delete',
  ElectricalMeasurementDeviceADMIN = 'electrical-measurement-devices:admin',
  ElectricalMeasurementCableCREATE = 'electrical-measurement-cables:create',
  ElectricalMeasurementCableREAD = 'electrical-measurement-cables:read',
  ElectricalMeasurementCableUPDATE = 'electrical-measurement-cables:update',
  ElectricalMeasurementCableDELETE = 'electrical-measurement-cables:delete',
  ElectricalMeasurementCableADMIN = 'electrical-measurement-cables:admin',
  EivamountCREATE = 'eivamounts:create',
  EivamountREAD = 'eivamounts:read',
  EivamountUPDATE = 'eivamounts:update',
  EivamountDELETE = 'eivamounts:delete',
  EivamountADMIN = 'eivamounts:admin',
  DocumenttypeCREATE = 'documenttypes:create',
  DocumenttypeREAD = 'documenttypes:read',
  DocumenttypeUPDATE = 'documenttypes:update',
  DocumenttypeDELETE = 'documenttypes:delete',
  DocumenttypeADMIN = 'documenttypes:admin',
  DocumentsubtypeCREATE = 'documentsubtypes:create',
  DocumentsubtypeREAD = 'documentsubtypes:read',
  DocumentsubtypeUPDATE = 'documentsubtypes:update',
  DocumentsubtypeDELETE = 'documentsubtypes:delete',
  DocumentsubtypeADMIN = 'documentsubtypes:admin',
  DocumentsGeneratorCREATE = 'documents-generator:create',
  DocumentsGeneratorREAD = 'documents-generator:read',
  DocumentsGeneratorUPDATE = 'documents-generator:update',
  DocumentsGeneratorDELETE = 'documents-generator:delete',
  DocumentsGeneratorADMIN = 'documents-generator:admin',
  DocumentCREATE = 'documents:create',
  DocumentREAD = 'documents:read',
  DocumentUPDATE = 'documents:update',
  DocumentDELETE = 'documents:delete',
  DocumentADMIN = 'documents:admin',
  DocumentTemplatesCREATE = 'documents:create',
  DocumentTemplatesREAD = 'documents:read',
  DocumentTemplatesUPDATE = 'documents:update',
  DocumentTemplatesDELETE = 'documents:delete',
  DocumentTemplatesADMIN = 'documents:admin',
  DebtorCREATE = 'debtors:create',
  DebtorREAD = 'debtors:read',
  DebtorUPDATE = 'debtors:update',
  DebtorDELETE = 'debtors:delete',
  DebtorADMIN = 'debtors:admin',
  ContainertypeCREATE = 'containertypes:create',
  ContainertypeREAD = 'containertypes:read',
  ContainertypeUPDATE = 'containertypes:update',
  ContainertypeDELETE = 'containertypes:delete',
  ContainertypeADMIN = 'containertypes:admin',
  ContainerCREATE = 'container:create',
  ContainerREAD = 'container:read',
  ContainerUPDATE = 'container:update',
  ContainerDELETE = 'container:delete',
  ContainerADMIN = 'container:admin',
  ContactCREATE = 'contacts:create',
  ContactREAD = 'contacts:read',
  ContactUPDATE = 'contacts:update',
  ContactDELETE = 'contacts:delete',
  ContactADMIN = 'contacts:admin',
  CommentCREATE = 'comments:create',
  CommentREAD = 'comments:read',
  CommentUPDATE = 'comments:update',
  CommentDELETE = 'comments:delete',
  CommentADMIN = 'comments:admin',
  ChatCREATE = 'chats:create',
  ChatREAD = 'chats:read',
  ChatUPDATE = 'chats:update',
  ChatDELETE = 'chats:delete',
  ChatADMIN = 'chats:admin',
  CategoryCREATE = 'categories:create',
  CategoryREAD = 'categories:read',
  CategoryUPDATE = 'categories:update',
  CategoryDELETE = 'categories:delete',
  CategoryADMIN = 'categories:admin',
  CalculationCREATE = 'calculations:create',
  CalculationREAD = 'calculations:read',
  CalculationUPDATE = 'calculations:update',
  CalculationDELETE = 'calculations:delete',
  CalculationADMIN = 'calculations:admin',
  CalculationitemsGroupCREATE = 'calculationitems-groups:create',
  CalculationitemsGroupREAD = 'calculationitems-groups:read',
  CalculationitemsGroupUPDATE = 'calculationitems-groups:update',
  CalculationitemsGroupDELETE = 'calculationitems-groups:delete',
  CalculationitemsGroupADMIN = 'calculationitems-groups:admin',
  CalculationitemCREATE = 'calculationitems:create',
  CalculationitemREAD = 'calculationitems:read',
  CalculationitemUPDATE = 'calculationitems:update',
  CalculationitemDELETE = 'calculationitems:delete',
  CalculationitemADMIN = 'calculationitems:admin',
  CalculationTemplateCREATE = 'calculation-templates:create',
  CalculationTemplateREAD = 'calculation-templates:read',
  CalculationTemplateUPDATE = 'calculation-templates:update',
  CalculationTemplateDELETE = 'calculation-templates:delete',
  CalculationTemplateADMIN = 'calculation-templates:admin',
  BusinessunitCREATE = 'businessunits:create',
  BusinessunitREAD = 'businessunits:read',
  BusinessunitUPDATE = 'businessunits:update',
  BusinessunitDELETE = 'businessunits:delete',
  BusinessunitADMIN = 'businessunits:admin',
  BusinessdivisionCREATE = 'businessdivisions:create',
  BusinessdivisionREAD = 'businessdivisions:read',
  BusinessdivisionUPDATE = 'businessdivisions:update',
  BusinessdivisionDELETE = 'businessdivisions:delete',
  BusinessdivisionADMIN = 'businessdivisions:admin',
  BuildingserviceCREATE = 'buildingservice:create',
  BuildingserviceREAD = 'buildingservice:read',
  BuildingserviceUPDATE = 'buildingservice:update',
  BuildingserviceDELETE = 'buildingservice:delete',
  BuildingserviceADMIN = 'buildingservice:admin',
  BudgetControllingREPORT = 'reports:budget-controlling',
  BudgetControllingMANAGEMENT = 'reports:budget-management',
  AuthenticatorCREATE = 'authenticator:create',
  AuthenticatorREAD = 'authenticator:read',
  AuthenticatorUPDATE = 'authenticator:update',
  AuthenticatorDELETE = 'authenticator:delete',
  AuthenticatorADMIN = 'authenticator:admin',
  AudienceCREATE = 'audiences:create',
  AudienceREAD = 'audiences:read',
  AudienceUPDATE = 'audiences:update',
  AudienceDELETE = 'audiences:delete',
  AudienceADMIN = 'audiences:admin',
  ArchiveboxCREATE = 'archiveboxes:create',
  ArchiveboxREAD = 'archiveboxes:read',
  ArchiveboxUPDATE = 'archiveboxes:update',
  ArchiveboxDELETE = 'archiveboxes:delete',
  ArchiveboxADMIN = 'archiveboxes:admin',
  AppDeviceCREATE = 'appdevices:create',
  AppDeviceREAD = 'appdevices:read',
  AppDeviceUPDATE = 'appdevices:update',
  AppDeviceDELETE = 'appdevices:delete',
  AppDeviceADMIN = 'appdevices:admin',
  AgentCREATE = 'agents:create',
  AgentREAD = 'agents:read',
  AgentUPDATE = 'agents:update',
  AgentDELETE = 'agents:delete',
  AgentADMIN = 'agents:admin',
  ActivitytypeCREATE = 'activitytypes:create',
  ActivitytypeREAD = 'activitytypes:read',
  ActivitytypeUPDATE = 'activitytypes:update',
  ActivitytypeDELETE = 'activitytypes:delete',
  ActivitytypeADMIN = 'activitytypes:admin',
  AccountingREAD = 'accounting:read',
  AccountingADMIN = 'accounting:admin',
  AbsenceCREATE = 'absences:create',
  AbsenceREAD = 'absences:read',
  AbsenceUPDATE = 'absences:update',
  AbsenceDELETE = 'absences:delete',
  AbsenceADMIN = 'absences:admin'
}
